import type {
  ChargebackReasonCode,
  DisputeSource,
  DisputeStatus,
} from '../dataProvider/types';

/** Display helpers for the Chargebacks surface (D-chargebacks). */

export const DISPUTE_STATUS_LABEL: Record<DisputeStatus, string> = {
  none: 'No dispute',
  received: 'Received',
  under_review: 'Under review',
  won: 'Won',
  lost: 'Lost',
};

export const DISPUTE_STATUS_COLOR: Record<
  DisputeStatus,
  'default' | 'warning' | 'info' | 'success' | 'error'
> = {
  none: 'default',
  received: 'warning',
  under_review: 'info',
  won: 'success',
  lost: 'error',
};

export const DISPUTE_SOURCE_LABEL: Record<DisputeSource, string> = {
  member: 'Member',
  network: 'Network',
  issuer: 'Card issuer',
};

export const CHARGEBACK_REASON_LABEL: Record<ChargebackReasonCode, string> = {
  fraud: 'Fraud',
  goods_not_received: 'Goods not received',
  duplicate: 'Duplicate',
  not_recognised: 'Not recognised',
  other: 'Other',
};
